import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SideNavComponent } from '../shared/side-nav/side-nav.component';
import { TopNavComponent } from '../shared/top-nav/top-nav.component';
import { OrganizationChartComponent } from '../organization-chart/organization-chart.component';

@Component({
  selector: 'app-employees-list',
  standalone: true,
  imports: [
    TopNavComponent,
    SideNavComponent,
    CommonModule,
    OrganizationChartComponent,
  ],
  templateUrl: './employees-list.component.html',
  styleUrl: './employees-list.component.scss',
})
export class EmployeesListComponent {
  currentView: 'table' | 'orgchart' = 'table';

  employees = [
    {
      id: 1,
      name: 'Joaquín Moisés',
      job: 'Developer',
      time: '5 months',
      strengths: ['Leader', 'Design', 'HTML'],
      project: 'AZ Translate',
    },
    {
      id: 2,
      name: 'Joaquín Moisés',
      job: 'Developer',
      time: '5 months',
      strengths: ['Leader', 'Design', 'HTML'],
      project: 'AZ Translate',
    },
    {
      id: 3,
      name: 'Joaquín Moisés',
      job: 'Developer',
      time: '5 months',
      strengths: ['Leader', 'Design', 'HTML'],
      project: 'AZ Translate',
    },
    // ...más empleados
  ];

  constructor(private router: Router) {}

  setView(view: 'table' | 'orgchart') {
    this.currentView = view;
  }

  viewDetails(id: number) {
    this.router.navigate(['/employee', id]);
  }
}
